import React from 'react';

interface StepProgressBarProps {
  currentStep: number;
  steps: string[];
}

const StepProgressBar: React.FC<StepProgressBarProps> = ({ currentStep, steps }) => {
  const getStepClassName = (index: number): string => {
    const baseClasses = "w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center mb-2 transition-all duration-300";
    
    if (index + 1 === currentStep) {
      return `${baseClasses} bg-[#A42823] text-white`;
    }
    if (index + 1 < currentStep) {
      return `${baseClasses} bg-[#A42823] text-white`;
    }
    return `${baseClasses} bg-white text-gray-400 border-2 border-gray-200`;
  };

  const getStepTextClassName = (index: number): string => {
    const baseClasses = "text-xs sm:text-sm transition-all duration-300";
    
    if (index + 1 === currentStep) {
      return `${baseClasses} text-black font-medium`;
    }
    if (index + 1 < currentStep) {
      return `${baseClasses} text-[#A42823] font-medium`;
    }
    return `${baseClasses} text-gray-400`;
  };

  return (
    <div className="flex justify-between items-center mb-2 relative mx-4 sm:mx-12 md:mx-16 lg:mx-20 xl:mx-[90px]">
      {/* Progress Line */}
      <div className="absolute h-[2px] bg-gray-200 left-0 right-0 top-[18px] -translate-y-1/2 z-0 mx-[44px]">
        {/* Active progress line */}
        <div
          className="h-full bg-[#A42823] transition-all duration-300"
          style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
        />
      </div>

      {/* Steps */}
      {steps.map((step, index) => (
        <div key={step} className="flex flex-col items-center relative z-10">
          <div className={getStepClassName(index)}>
            {index + 1 < currentStep ? (
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              index + 1
            )}
          </div>
          <span className={`${getStepTextClassName(index)} hidden sm:block`}>
            {step}
          </span>
        </div>
      ))}
    </div>
  );
};

export default StepProgressBar; 